<script setup lang="ts">
const props = defineProps<{
    name: string;
}>();

const icons: Record<string, string[]> = {
    shield: ['M12 3 4 6v6c0 5 3.5 9 8 11 4.5-2 8-6 8-11V6l-8-3Z'],
    arrowDown: ['M12 5v13', 'M6 12l6 6 6-6'],
    arrowRight: ['M5 12h13', 'M12 6l6 6-6 6'],
    check: ['m5 12 4 4L19 6'],
    lock: ['M8 11V8a4 4 0 0 1 8 0v3', 'M6 11h12v10H6z'],
    copy: ['M9 9h9v11H9z', 'M6 15H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1'],
    eraser: ['m7 16 8-8 4 4-8 8H7Z', 'm13 10 3-3 4 4'],
    sparkles: ['M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6L12 3Z', 'M19 16l.8 2.2L22 19l-2.2.8L19 22l-.8-2.2L16 19l2.2-.8L19 16Z'],
    plus: ['M12 5v14', 'M5 12h14'],
    user: ['M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z', 'M5 20a7 7 0 0 1 14 0'],
    chevronDown: ['m6 9 6 6 6-6'],
    alert: ['M12 3 2 21h20L12 3Z', 'M12 9v5', 'M12 18h.01'],
    file: ['M8 3h6l5 5v13H8z', 'M14 3v5h5'],
    bot: ['M12 2v4', 'M7 8h10a3 3 0 0 1 3 3v5a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-5a3 3 0 0 1 3-3Z', 'M9 13h.01', 'M15 13h.01', 'M9 17h6'],
    userCheck: ['M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z', 'M5 20a7 7 0 0 1 10.5-6', 'm17 17 2 2 4-4'],
    rotate: ['M3 12a9 9 0 1 0 3-6.7', 'M3 4v4h4'],
    mail: ['M3 6h18v12H3z', 'm3 7 9 7 9-7'],
    checkCircle: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z', 'm8.5 12 2.5 2.5 5-5'],
    pencil: ['m4 20 4.5-1 9.5-9.5-3.5-3.5L5 16z', 'm13.5 5.5 3.5 3.5'],
};
</script>

<template>
    <svg
        aria-hidden="true"
        class="gdpr-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <path
            v-for="line in icons[props.name] ?? []"
            :key="line"
            :d="line"
        />
    </svg>
</template>
